export default __webpack_public_path__ + "static/media/aunt.f7183e86.ogg";